import { CompareTableColumn } from "in_queue/components/compare/comparisons";
import { ScenarioConstraint } from "in_queue/types/scenarioResultType";
import {
    dfaxFormatter,
    roundingFormatter
} from "../tables/agGrid/agGridHelpers";

export const constraintsCompareColumns: ReadonlyArray<
    CompareTableColumn<ScenarioConstraint>
> = [
    {
        kind: "join",
        colId: "projectId",
        headerName: "Project",
        getValue: (r) => r.projectId,
        width: 150
    },
    {
        kind: "join",
        colId: "monitoredFacilityName",
        headerName: "Monitored facility",
        getValue: (r) => r.monitoredFacilityName,
        flex: 1
    },
    {
        kind: "display",
        colId: "constraintType",
        headerName: "Type",
        getValue: (rep) => rep.constraintType,
        width: 100
    },
    {
        kind: "compare",
        colId: "dfax",
        headerName: "Dfax",
        getValue: (r) => r.dfax,
        valueFormatter: dfaxFormatter,
        filterable: false,
        sort: "desc"
    },
    {
        kind: "compare",
        colId: "mwImpact",
        headerName: "MW Impact",
        getValue: (r) => r.mwImpact ?? null,
        valueFormatter: roundingFormatter
    },
    {
        kind: "compare",
        colId: "postStudyFlow",
        headerName: "Study Load",
        getValue: (r) => r.postStudyLoad ?? null,
        valueFormatter: roundingFormatter
    },
    {
        kind: "compare-text",
        colId: "worstContingencyName",
        headerName: "Worst contingency",
        getValue: (r) => r.worstContingencyName ?? "",
        width: 150
    }
];
